// This file is used to store MyInfo mapping, where it return correspond display label correspond to the key
// It is imported by MyInfoView.vue;
// By using this data structure, MyInfoView can generate array list that has attributes of
// 'label, key, included, isLockFieldElement' and displayed on UI accordingly
import { CountryOptions, NationalityOptions } from '@master/model/options/NationalityAndCountryOptions'

export const PERSONAL_DATA_STRUCTURE = [{
  label: 'Name',
  key: 'name'
}, {
  label: 'NRIC',
  key: 'nric'
}, {
  label: 'Sex',
  key: 'gender'
}, {
  label: 'Date of Birth',
  key: 'dob',
  type: 'timeStamp'
}, {
  label: 'Citizenship',
  key: 'citizenship'
}, {
  label: 'Nationality',
  key: 'citizenship_specified',
  mapWith: NationalityOptions
}, {
  label: 'Marital Status',
  key: 'marital_status'
}, {
  label: 'Race',
  key: 'race'
}, {
  label: 'Country of Birth',
  key: 'country_of_birth',
  mapWith: CountryOptions
}, {
  label: 'Mobile Number',
  key: 'contact_mobile'
}, {
  label: 'Home Contact',
  key: 'contact_home'
}, {
  label: 'Email',
  key: 'contact_email'
}, {
  label: 'Postcode',
  key: 'postal_code'
}, {
  label: 'Address',
  key: 'residential_address'
}, {
  label: 'Employer\'s Name',
  key: 'company_name'
}, {
  label: 'Occupation',
  key: 'occupation'
}, {
  label: 'Education Level',
  key: 'education_level'
}]

export const FINANCIAL_DATA_STRUCTURE = [{
  category: 'CPF',
  group: [{
    label: 'CPF (OA)',
    key: 'cpf_ordinary'
  }, {
    label: 'CPF (SA)',
    key: 'cpf_special'
  }, {
    label: 'CPF (MA)',
    key: 'cpf_medisave'
  }, {
    label: 'CPF (RA)',
    key: 'cpf_retirement'
  }]
}, {
  category: 'Notice Of Assessment',
  group: [{
    label: 'Annual Income',
    key: 'annual_income'
  }, {
    label: 'Year of Assessment',
    key: 'noa_yearofassessment'
  }, {
    label: 'Employment',
    key: 'employment'
  }, {
    label: 'Business',
    key: 'business'
  }, {
    label: 'Rent',
    key: 'rental_income'
  }, {
    label: 'Dividends',
    key: 'dividends'
  }]
}, {
  category: 'household',
  group: [{
    label: 'Monthly HouseHold Income',
    key: 'monthly_household_income'
  }]
}]

export const PROPERTY_DATA_STRUCTURE = [
  {
    label: 'Date of Purchase',
    key: 'prop_financing_date_of_purchase',
    type: 'timeStamp'
  }, {
    label: 'Original Loan Repayment Period',
    key: 'prop_financing_original_loan_period'
  }, {
    label: 'Monthly Loan Instalment',
    key: 'prop_financing_monthly_instalment_total'
  }, {
    label: 'Housing Loan Outstanding',
    key: 'prop_financing_housing_loan_outstanding'
  }, {
    label: 'Balance Loan Repayment Period',
    key: 'prop_financing_remaining_housing_loan_term_years'
  }, {
    label: 'Address',
    key: 'prop_financing_address'
  }, {
    label: 'Type of HDB Dwelling',
    key: 'prop_financing_type_of_property'
  }
]
